const DEV = {
    "baseUrl": "http://localhost:2999/v1/"
};

const PROD = {
    "baseUrl": "https://transactions.kjdelectronics.com/v1/"
};

const config = process.env.NODE_ENV.toLowerCase() === 'production' ? PROD : DEV;

module.exports.config = config;